import HeroSection from "../components/Hero";
// import VideoSession from "../components/video_session";
import SaveMoney from "../components/save_money";
import Review from "../components/review";
import Questions from "../components/Questions";
import Footer from "../components/Footer";


const LandingPage = () => {
    return (
        <div className="font-sans relative sm:text-left">
      
      <HeroSection />
      {/* <div className="mt-[200px]"></div> */}
      
      <SaveMoney />
      <Review />  
      <Questions />
      <Footer />
     
      


    
    </div>

);
};
export default LandingPage;